/**
 * Utility function to convert text to slug
 * @param {string} text 
 * @returns {string}
 */
export const slugify = (text) => {
    if (!text) return "";
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")           // Replace spaces with -
        .replace(/[^\w-]+/g, "")       // Remove all non-word chars
        .replace(/--+/g, "-");          // Replace multiple - with single -
};
